import React, { ElementType } from 'react';
import { Tooltip } from 'antd';
import { COLOR_SUCCESS } from '../../../app-constants';

interface OwnProps {
  title: string;
  enabled?: boolean;
  icon: ElementType;
  className?: string;
  colorToSet?: string;
}

const DataStatusIcon = ({ title, enabled = false, icon, className, colorToSet }: OwnProps) => {
  let color = colorToSet;
  if (!colorToSet) {
    color = enabled ? COLOR_SUCCESS : 'grey';
  }
  const Icon = icon;
  return (
    <Tooltip title={title} className={className}>
      <Icon style={{ color }} />
    </Tooltip>
  );
};

export default React.memo(DataStatusIcon);
